import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'popover-container',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent {}
